import {AxiosError} from 'axios';
import {POST_REQUEST_FILE_PRESIGNED_URL} from 'web-library/constants/apiUrls';
import {
  RequestFileRequest,
  RequestFileResponse,
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";
// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: RequestFileResponse[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostRequestFilePresigned = ({onSuccess, onError}: Input = {}) => {
  const postRequestFilePresigned = async (requestData: RequestFileRequest) => {
    const res = await axiosClient.post<RequestFileResponse[]>(
        POST_REQUEST_FILE_PRESIGNED_URL,
        requestData
    );
    return res.data;
  };

  return useCustomMutation(postRequestFilePresigned, {
    onSuccess,
    onError,
  });
};
